import { render, staticRenderFns } from "./app--api-notification.vue?vue&type=template&id=4e9d85de&"
import script from "./app--api-notification.vue?vue&type=script&lang=js&"
export * from "./app--api-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports